import React from 'react'
import { supabase } from '../supabase'

const THEMES = {
  'morning-glory': { name: 'Morning Glory & Peach', header: '#2d6973', accent: '#fbc78d' },
  'orange-lichen': { name: 'Orange Lichen', header: '#b84a18', accent: '#f7c74b' },
  'blue-lichen': { name: 'Blue Lichen', header: '#3a3d58', accent: '#d48d38' },
  'peach-half-baked': { name: 'Peach & Half Baked', header: '#85cbcc', accent: '#fbc78d' },
  'cognac-teal': { name: 'Cognac & Teal', header: '#7a3a18', accent: '#3e8a84' },
}

export default function Settings({ theme: t, currentTheme, onThemeChange, onClose }) {
  const handleLogout = async () => {
    await supabase.auth.signOut()
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 100, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div style={{ background: t.card, borderRadius: '20px 20px 0 0', width: '100%', maxWidth: '430px', padding: '24px', paddingBottom: '48px' }}>

        <div style={{ width: '40px', height: '4px', borderRadius: '2px', background: t.border, margin: '0 auto 20px' }}></div>

        <div style={{ fontFamily: 'Dancing Script, cursive', fontSize: '26px', fontWeight: '700', color: t.header, marginBottom: '20px' }}>Settings</div>

        {/* Theme picker */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '.8px', textTransform: 'uppercase', color: t.textLight, marginBottom: '12px' }}>Theme</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {Object.entries(THEMES).map(([key, theme]) => (
              <div
                key={key}
                onClick={() => onThemeChange(key)}
                style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 14px', borderRadius: '12px', border: `1px solid ${currentTheme === key ? t.header : t.border}`, background: currentTheme === key ? `${t.header}12` : t.bg, cursor: 'pointer' }}
              >
                {/* Theme swatch */}
                <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                  <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: theme.header }}/>
                  <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: theme.accent }}/>
                </div>
                <div style={{ fontSize: '13px', fontWeight: '400', color: t.text, flex: 1 }}>{theme.name}</div>
                {currentTheme === key && (
                  <div style={{ width: '18px', height: '18px', borderRadius: '50%', background: t.header, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#fff' }}/>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Sign out */}
        <div
          onClick={handleLogout}
          style={{ padding: '12px', borderRadius: '12px', border: `1px solid ${t.border}`, fontSize: '13px', fontWeight: '400', color: t.textLight, textAlign: 'center', cursor: 'pointer', marginBottom: '12px' }}
        >
          Sign out
        </div>

        <div
          onClick={onClose}
          style={{ padding: '12px', borderRadius: '12px', background: t.header, fontSize: '13px', fontWeight: '500', color: '#e8f8f6', textAlign: 'center', cursor: 'pointer' }}
        >
          Done
        </div>
      </div>
    </div>
  )
}